<template>
  <div class="app-file-list-show">
    <ul class="clearfix" style="display: flex">
      <li
        v-for="(item, index) in fileInfoList"
        :key="index"
        @click="showViewer(Bus.imgPath(item.fileCode), item)"
        class="fl img-item"
      >
        <!-- 图片 -->
        <img
          v-if="item.fileType === 0"
          :src="Bus.imgPath(item.fileCode)"
          @click="showViewer(Bus.imgPath(item.fileCode), $event)"
          onerror="this.src='/images/theme/newDark/default.png'"
        />
        <!-- 视频 -->
        <video
          title="双击放大播放"
          v-if="item.fileType === 1"
          :src="Bus.downFile(item.fileCode)"
          controls="controls"
        >
          您的浏览器不支持 video 标签。
        </video>
        <img
          v-if="item.fileType != 0 && item.fileType != 1"
          :src="alarmImage(item)"
          @click="showViewer(Bus.imgPath(item.fileCode), $event)"
          onerror="this.src='/images/theme/newDark/default.png'"
        />
      </li>
    </ul>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>
<script>
import { Bus, Cache } from "$utils";
export default {
  props: ["fileInfoList", "taskAlarmInfo"],
  data() {
    return {
      Bus,
      viewerInstance: null,
      viewerPhotos: [],
      resourceShow: false,
      currentResource: [],
    };
  },
  mounted() {
    console.log(this.Bus);
  },
  methods: {
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(src, item) {
      if (item.fileType !== 1) {
        this.viewerPhotos = [src];
        this.viewerInstance.show();
      }
    },
    // 图片
    enlargeImage(item) {
      // this.$emit('enlargeImage', item)
    },
    alarmImage(item) {
      const token = Cache.get("access_token");
      let url = "";
      switch (item.fileType) {
        case 0:
          url = `/bas/safeEvent/picStreamInfo.json?resourceCode=${this.taskAlarmInfo.resourceCode}&ticket=${token}`;
          break;
        case 4:
          url = `/bas/safeEvent/picStreamInfo.json?alarmId=${this.taskAlarmInfo.alarmId}&alarmType=${this.taskAlarmInfo.alarmType}&deviceId=${this.taskAlarmInfo.alarmDevId}&picResourceType=3&ticket=${token}`;
          break;
        case 3:
          url = `/bas/safeEvent/picStreamInfo.json?alarmId=${this.taskAlarmInfo.alarmId}&alarmType=${this.taskAlarmInfo.alarmType}&picResourceType=4&ticket=${token}`;
          break;
        default:
          url = `/bas/safeEvent/picStreamInfo.json?picResourceType=${item.fileType}&alarmType=${this.taskAlarmInfo.alarmType}&alarmId=${this.taskAlarmInfo.alarmId}&ticket=${token}&resourceCode=${this.taskAlarmInfo.resourceCode}`;
      }
      console.log(url);
      return url;
    },
  },
};
</script>
<style lang="scss" scoped>
.img-item {
  cursor: pointer;
  // width: 100px;
  width: 100%;
  margin-right: 10px;
  position: relative;
  height: 150px;
  // &::before {
  //   content: "";
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 1;
  //   left: 0;
  //   top: 0;
  // }
  img,
  video {
    // width: 100px;
    width: 100%;
    height: 150px;
  }
  .video-box {
    width: 100px;
    height: 100px;
  }
}
</style>
